import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Form, { Button, Label, Row, Col, Input, Container, UncontrolledTooltip } from 'reactstrap';
import { AvFeedback, AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

import {
    loadPosSettings,
    loadPosTypes,
    loadTimezones,
    savePosSettingsData,
    importMenu,
    canUserAccessPosSettings,
    resetUserAccessToPos,
    wipeMenu,
    activateMenu,
    sendMenuuOrderHubLogs
} from '../../../../actions/index';
import { convertCheckBoxValueToBoolean, isMenuuPOS, isUserAllowedToAddBrands } from '../../../../utils/CommonUtils';
import ConfirmationScreen from './ConfirmationScreen';
import ImportMenuFromCSVScreen from '../../posmenu/ImportMenuFromCSVScreen';
import {
    ANDROMEDA_POS_TYPE_ID,
    GOODCOM_POS_TYPE_ID
} from '../../../../utils/Constants';
import PasswordVerificationScreen from '../../../common/PasswordVerificationScreen';
class PosSettingsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: -1,
            allowToppingsSubstitution: false,
            autoSync: false,
            autoSyncHour: null,
            autoSyncMinute: null,
            kioskQuestionsOnly: false,
            type: {
                id: -1,
                template: '',
                value: ''
            },
            menuuPOSemail: null,
            stateAlreadyCopiedFromProps: false,
            confirmationScreenOpened: false,
            importMenuScreenOpened: false,
            userPassword: null,
            wipeMenuConfirmationScreenOpened: false
        };

        this.toggleConfirmationScreen = this.toggleConfirmationScreen.bind(this);
        this.toggleImportMenuFromCSVScreen = this.toggleImportMenuFromCSVScreen.bind(this);
        this.changeState = this.changeState.bind(this);
        this.selectPosType = this.selectPosType.bind(this)
        this.importMenu = this.importMenu.bind(this);
        this.savePosSettings = this.savePosSettings.bind(this);
        this.updatePosSettings = this.updatePosSettings.bind(this);
        this.wipeMenuToggle = this.wipeMenuToggle.bind(this);
        this.wipeMenuConfirm = this.wipeMenuConfirm.bind(this);
        this.activateMenu = this.activateMenu.bind(this);
    }

    componentWillMount() {
        const { id } = this.props.match.params;

        this.props.loadPosTypes();
        this.props.loadTimezones();
        this.props.loadPosSettings(id);
    }

    componentWillUnmount() {
        this.props.resetUserAccessToPos();
    }

    copyStateFromProps() {
        const { posSettings } = this.props;

        if (posSettings !== undefined && posSettings !== null && posSettings.id !== undefined && posSettings.id !== -1 && posSettings.type !== null
            && (!this.state.stateAlreadyCopiedFromProps || posSettings.id !== this.state.id)) {

            this.setState({
                id: posSettings.id,
                allowToppingsSubstitution: posSettings.allowToppingsSubstitution,
                autoSync: posSettings.autoSync,
                autoSyncHour: posSettings.autoSyncHour,
                autoSyncMinute: posSettings.autoSyncMinute,
                kioskQuestionsOnly: posSettings.kioskQuestionsOnly,
                type: {
                    id: posSettings.type.id,
                    template: posSettings.type.template,
                    value: posSettings.type.value,
                    supportCsvFiles: posSettings.type.supportCsvFiles
                },
                stateAlreadyCopiedFromProps: true
            }, () => {
                const posTypeTemplateFieldsString = this.getFieldsFromString(posSettings.type.template);


                if (posTypeTemplateFieldsString === undefined || posTypeTemplateFieldsString === null || posTypeTemplateFieldsString === '') {
                    return;
                }

                // if (!(posSettings.settings.indexOf('ID') !== -1)) {
                const settings = JSON.parse(posSettings.settings);

                const posTypeTemplateFields = posTypeTemplateFieldsString.split(",");

                posTypeTemplateFields.map((item) => {

                    this.setState({
                        [item]: this.getPosFieldValue(item, settings)
                    });

                });
                // }
            });

        }
    }

    supportCsvFiles() {
        if (this.state.type.id !== undefined && this.state.type.id !== null) {
            return this.state.type.supportCsvFiles;
        }
    }

    toggleImportMenuFromCSVScreen() {
        this.setState({
            importMenuScreenOpened: !this.state.importMenuScreenOpened
        });
    }

    toggleConfirmationScreen() {
        this.setState({
            confirmationScreenOpened: !this.state.confirmationScreenOpened
        });
    }

    getFieldsFromString(stringOfFields) {
        const fields = stringOfFields.replace(/\"/g, "").replace(/\[/g, "").replace(/\]/g, "").replace(/\ /g, "");
        return fields;
    }

    changeState({ target }) {
        // For some reason, it accepts values "0" and "1" as false and true.
        // It is happening only in minimumQuantity and maximumQuantity.

        if (target.value !== 1 && target.value !== '1' && target.value !== 0 && target.value !== '0') {
            if (target.value == true || target.value == 'true' || target.value == false || target.value == 'false') {
                this.setState({
                    ...this.state,
                    [target.name]: convertCheckBoxValueToBoolean({ target })
                });
            } else {
                this.setState({
                    ...this.state,
                    [target.name]: target.value
                });
            }
        } else {
            this.setState({
                ...this.state,
                [target.name]: target.value
            });
        }
    }

    renderHeading() {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <div><MaterialIcon icon="personal_video" size={22} color="#0288d1" />&nbsp;
                    {i18n.t('screens:restaurantsSettingsContainer.pos')}</div>
            </div>
        );
    }

    renderInfoMessage() {
        return (
            <div style={{ display: 'flex', paddingRight: 25 }}>
                <span id={'infoIcon'}>
                    <MaterialIcon icon='info' color="#0288D1" size={22}/>&nbsp; 
                </span>
                <UncontrolledTooltip placement="top" target={'infoIcon'}>
                    {i18n.t('screens:restaurantsSettingsContainer.giftCardsNotSupportingAndromeda')}
                </UncontrolledTooltip>
            </div>
        )
    }

    renderPosTypeSelect() {
        const { posTypeSelectGroup, labelSelectStyle, posTypeSelectStyle } = styles;

        return (
            <AvGroup style={posTypeSelectGroup} id="postypeSelect">
                <Label style={labelSelectStyle}>{i18n.t('screens:restaurantsScreen.posType')}</Label>
                <AvField style={posTypeSelectStyle} type="select" name="id" id="postype"
                    value={this.state.type.id}
                    onChange={this.selectPosType}
                    errorMessage={i18n.t('common:validations.choosePosType')}
                    required>
                    <option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                    {this.props.posTypes.map((item, i) => {
                        return (<option value={item.id} id={item.id} key={i}>{item.value}</option>)
                    })}
                </AvField>
            </AvGroup>
        );
    }

    selectPosType({ target }) {
        this.state.type.id = Number(target.value);

        if (target.value === '') {
            this.setState({
                type: {
                    ...this.state.type,
                    value: '',
                    template: '',
                    supportCsvFiles: false
                }
            });

            return;
        }

        let posTypeTemplateFieldsString;

        for (let i = 0; i < this.props.posTypes.length; i++) {
            let posType = this.props.posTypes[i];

            if (posType.id === this.state.type.id) {
                this.setState({
                    type: {
                        ...this.state.type,
                        value: posType.value,
                        template: posType.template,
                        supportCsvFiles: posType.supportCsvFiles
                    }
                });
                posTypeTemplateFieldsString = this.getFieldsFromString(posType.template);

                break;
            }
        }

        if (posTypeTemplateFieldsString === undefined || posTypeTemplateFieldsString === null || posTypeTemplateFieldsString === '') {
            return;
        }

        const posTypeTemplateFields = posTypeTemplateFieldsString.split(",");

        posTypeTemplateFields.map((item) => {
            this.setState({
                [item]: ''
            });
        });
    }

    renderPosSettingsFields() {
        const { posAdditionalFields } = styles;

        if (this.state.type.template === undefined || this.state.type.template === null || this.state.type.template === '') {
            return;
        }

        const posTypeTemplateFieldsString = this.getFieldsFromString(this.state.type.template);
        const posTypeTemplateFields = posTypeTemplateFieldsString.split(",");

        return (
            <div className="form-row" style={posAdditionalFields}>
                {
                    posTypeTemplateFields.map((item, i) => {
                        return this.renderPosField(item, i)
                    })
                }
            </div>
        );
    }

    renderPosField(item, i) {
        const { posTypeFieldGroups, labelStyle, posTypeInputStyle } = styles;
        let inputFieldStyle = posTypeInputStyle;

        if (item !== undefined || item !== null) {

            const isFieldRequired = !this.supportCsvFiles();

            return (
                <AvGroup key={i} style={posTypeFieldGroups}>
                    <Label for={item} style={labelStyle} >{i18n.t(`screens:posSettingsScreen.${item}`)}</Label>
                    <Input style={inputFieldStyle}
                        type="text" name={item} id={item}
                        placeholder={this.getPosFieldPlaceholder(item)}
                        value={this.getPosFieldValue(item, this.state)}
                        onChange={this.changeState}
                        disabled={this.state.type.id === 14 ? false : this.supportCsvFiles()}
                        required={isFieldRequired}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </AvGroup>
            );
        }
    }

    getPosFieldValue(item, state) {
        const value = state[item];
        if (this.supportCsvFiles() || (value === undefined || value === null || value === '')) {
            if (item == 'restaurantId') {
                return this.props.match.params.id;
            } else if (item == 'pushToken') {
                return '';
            }
        }

        return value;
    }

    getPosFieldPlaceholder(item) {
        if (this.supportCsvFiles() && item === 'pushToken') {
            return i18n.t('screens:posSettingsScreen.notConnected');
        } else {
            return '-';
        }
    }

    renderPriceSubstitutionSettings() {
        const { posAdditionalFields, autoSyncLabel, marginLeft } = styles;

        if (this.state.type.id == ANDROMEDA_POS_TYPE_ID || this.state.type.id === GOODCOM_POS_TYPE_ID) {
            return (
                <div className="form-row" style={posAdditionalFields}>
                    <AvGroup style={autoSyncLabel}>
                        <Label for="autoSync">{i18n.t('screens:posSettingsScreen.allowToppingsSubstitution')}</Label>
                        <AvInput type="checkbox" name="allowToppingsSubstitution"
                            value={this.state.allowToppingsSubstitution}
                            onChange={this.changeState}
                            style={marginLeft}
                        />
                    </AvGroup>
                </div>
            );
        }
    }

    renderAutosyncSettings() {
        const { posAdditionalFields, autoSyncLabel, marginLeft } = styles;

        if (this.supportCsvFiles()) {
            return null;
        } else {
            return (
                <div className="form-row" style={posAdditionalFields}>
                    <AvGroup style={autoSyncLabel}>
                        <Label for="autoSync">{i18n.t('screens:posSettingsScreen.autosync')}</Label>
                        <AvInput type="checkbox" name="autoSync"
                            value={!!this.state.autoSync}
                            onChange={this.changeState}
                            style={marginLeft}
                        />
                    </AvGroup>
                    {
                        this.state.type.id === 5 &&
                        <AvGroup style={autoSyncLabel}>
                            <Label>{i18n.t('screens:posSettingsScreen.kioskQuestions')}</Label>
                            <AvInput type="checkbox" name="kioskQuestionsOnly"
                                value={!!this.state.kioskQuestionsOnly}
                                onChange={this.changeState}
                                style={marginLeft}
                            />
                        </AvGroup>
                    }
                </div>
            );
        }
    }

    renderImportMenuButton() {
        const { importBtn, importPadding } = styles;
        const buttonText = (this.state.type.id === 11 && this.state.type.value === 'Ordermark') ? i18n.t('screens:menuConfigScreen.activate') : i18n.t('screens:menuConfigScreen.importMenuBtn');
        const iconType = (this.state.type.id === 11 && this.state.type.value === 'Ordermark') ? 'power_settings_new' : 'sync';
        const onClickFunction = (this.state.type.id === 11 && this.state.type.value === 'Ordermark') ? this.activateMenu : this.importMenu;

        return (
            <Button style={importBtn} color="primary" onClick={onClickFunction}>
                <MaterialIcon icon={iconType} color="#fff" size={18} />
                <span style={importPadding}>{buttonText}</span>
            </Button>
        );
    }

    renderWipeMenuButton() {
        const { wipeMenuBtn, importPadding } = styles;

        return (
            <Button style={wipeMenuBtn} color="primary" onClick={this.wipeMenuToggle}>
                <MaterialIcon icon="delete" color="#fff" size={18} />
                <span style={importPadding}>{i18n.t('screens:posSettingsScreen.wipeMenu')}</span>
            </Button>
        );
    }

    renderFormSaveButton() {
        const { spaceBetween } = styles;

        return (
            <Button type='submit' form='restaurantSettingsForm' color="primary">
                <MaterialIcon icon="save" color="#fff" size={18} />
                <span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
            </Button>
        );
    }

    renderAutosyncTime() {
        const { asyncTimeGroups, posAsyncTimeInput, labelAutosyncTimeStyle, autoSyncTimeContainer, syncTimeColor } = styles;
        let isAutosyncDisabled = true;

        if (this.state.autoSync == true || this.state.autoSync == "true") {
            isAutosyncDisabled = false;
        }

        let hours = [];
        const arrayHoursLength = 24;

        for (let i = 0; i < arrayHoursLength; i++) {
            hours.push(i);
        }

        let minutes = [0, 30];

        if (this.supportCsvFiles()) {
            return null;
        } else {
            return (
                <AvGroup style={asyncTimeGroups} id="autoSyncTimeGroup">
                    <label style={labelAutosyncTimeStyle}>{i18n.t('screens:posSettingsScreen.syncTime')}</label>
                    <div style={autoSyncTimeContainer}>
                        <AvField style={posAsyncTimeInput} type="select" name="autoSyncHour"
                            className="form-control"
                            value={(this.state.autoSyncHour == 0) ? '0' : this.state.autoSyncHour}
                            onChange={this.changeState}
                            disabled={isAutosyncDisabled}
                            required={!isAutosyncDisabled}>
                            <option value="">hh</option>
                            {
                                hours.map((hour, i) => {
                                    return (<option value={hour} key={i}>{hour}</option>)
                                })
                            }
                        </AvField>
                        <AvField style={posAsyncTimeInput} type="select" name="autoSyncMinute"
                            className="form-control"
                            value={(this.state.autoSyncMinute == 0) ? '0' : this.state.autoSyncMinute}
                            onChange={this.changeState}
                            disabled={isAutosyncDisabled}
                            required={!isAutosyncDisabled}>
                            <option value="">mm</option>
                            {
                                minutes.map((minute, i) => {
                                    if (minute == 0) {
                                        return (<option value={minute} key={i}>{minute}0</option>)
                                    } else {
                                        return (<option value={minute} key={i}>{minute}</option>)
                                    }
                                })
                            }
                        </AvField>
                    </div>
                    <div>
                        <br />
                        <small style={syncTimeColor}>{i18n.t('screens:posSettingsScreen.timeFormat')}</small>
                    </div>
                </AvGroup>
            );
        }
    }

    renderMenuuOrderHubLogs() {
        const { spaceBetween } = styles;
        const isUserAllowedToSendLogs = isUserAllowedToAddBrands(this.props.user);
        const isMenuuPOSSelected = isMenuuPOS(this.state.type);

        if (isUserAllowedToSendLogs && isMenuuPOSSelected) {
            return (
                <Fragment>
                    <AvForm id='sendMenuuOrderHubLogs' onValidSubmit={() => this.sendLogs()} style={{ display: 'flex', alignItems: 'center', width: '50%', margin: '28px 14px' }}>
                        <Label for='menuuPOSemail' style={{ paddingRight: 14 }} >{i18n.t('common:form.email')}</Label>
                        <Input style={{ display: 'flex', alignItems: 'center' }}
                            type="email"
                            name='menuuPOSemail'
                            id='menuuPOSemail'
                            value={this.state.menuuPOSemail}
                            onChange={this.changeState}
                        />
                        <Button type='submit' form='sendMenuuOrderHubLogs' color="primary" style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}>
                            <MaterialIcon icon="forward_to_inbox" color="#fff" size={18} />
                            <span style={spaceBetween}>{i18n.t('common:buttons.sendLogs')}</span>
                        </Button>
                    </AvForm>
                    <p style={{ fontSize: 14, marginLeft: 14 }}>* {i18n.t('screens:posSettingsScreen.menuPosNote')}</p>
                </Fragment>
            )
        }
    }

    renderCubohMessage() {
        return (
            <p style={{ fontSize: 14, marginLeft: 14 }}>* {i18n.t('screens:posSettingsScreen.cubohPosNote')}</p>
        )
    }

    sendLogs() {
        const email = this.state.menuuPOSemail;
        this.props.sendMenuuOrderHubLogs(email);
    }

    wipeMenuToggle() {
        this.setState({ ...this.state, wipeMenuConfirmationScreenOpened: !this.state.wipeMenuConfirmationScreenOpened });
    }

    wipeMenuConfirm() {
        this.props.wipeMenu(this.props.restaurant.id);
        this.wipeMenuToggle();
    }

    savePosSettings() {
        let isGeneralPosSettingChanged = false;

        if (this.props.posSettings !== undefined && this.props.posSettings !== null &&
            this.state.id !== undefined && this.state.id !== -1
            && (this.state.type.value === this.props.posSettings.type.value)) {

            isGeneralPosSettingChanged = this.checkAndromedaSettings(this.state);
        }

        if (this.state.id !== undefined && this.state.id !== -1
            && (isGeneralPosSettingChanged || this.state.type.value !== this.props.posSettings.type.value)) {

            const posType = this.props.posSettings.type ? this.props.posSettings.type.value : '';
            const currentPosType = this.state.type.value;

            if ((posType === 'Menuu' || posType === 'Email POS' || posType === 'Captiva') && (currentPosType === 'Menuu' || currentPosType === 'Email POS' || currentPosType === 'Captiva' || currentPosType === 'Goodcom')) {
                this.updatePosSettings()
            } else {
                this.toggleConfirmationScreen();
            }
        } else {

            this.props.savePosSettingsData(this.state, this.props.match.params.id);
            this.resetAutosyncTimeFields();
        }
    }

    updatePosSettings() {
        this.props.savePosSettingsData(this.state, this.props.match.params.id);
        this.resetAutosyncTimeFields();
    }

    resetAutosyncTimeFields() {
        if (this.state.autoSync == false || this.state.autoSync == 'false') {
            this.setState({
                autoSyncHour: '',
                autoSyncMinute: ''
            });
        }
    }

    checkAndromedaSettings(posSettings) {
        const posSettingsGeneralSettings = JSON.parse(this.props.posSettings.settings);

        if (posSettings !== undefined && posSettings !== null
            && posSettingsGeneralSettings !== undefined && posSettings !== null
            && posSettings.applicationId == posSettingsGeneralSettings.applicationId
            && posSettings.siteId == posSettingsGeneralSettings.siteId) {
            // This means nothing from the general settings changed.
            return false;
        } else {
            // This means something from the general settings changed!!!
            return true;
        }
    }

    importMenu() {
        if (this.supportCsvFiles()) {
            this.toggleImportMenuFromCSVScreen();
        } else {
            const { id } = this.props.match.params;
            this.props.importMenu(id, undefined);
        }
    }

    activateMenu() {
        this.props.activateMenu(this.props.restaurant.id);
    }

    renderPosSettingsForm() {
        return (
            <React.Fragment>
                <AvForm id="restaurantSettingsForm" onValidSubmit={this.savePosSettings}>
                    {this.renderPosTypeSelect()}
                    {this.renderPosSettingsFields()}
                    {this.renderPriceSubstitutionSettings()}
                    {this.renderAutosyncSettings()}
                    {this.renderAutosyncTime()}
                </AvForm>
                {this.renderMenuuOrderHubLogs()}
                {this.state.type.id === 14 && this.renderCubohMessage()}
            </React.Fragment>
        );
    }

    renderPasswordVerification() {

        return <PasswordVerificationScreen
            password={this.state.userPassword}
            onChange={this.changeState}
            onSubmit={() => this.props.canUserAccessPosSettings(this.state.userPassword)} />;
    }

    render() {
        const { containerStyle, errorContainerStyle, errorMessage } = styles;
        const posType = this.props.posSettings ? this.props.posSettings.type ? this.props.posSettings.type.value : '' : '';
        const currentPosType = this.state.type.value;
        const textData = {
            header: i18n.t('screens:posSettingsScreen.msgHeader'),
            firstRow: `${i18n.t(`screens:posSettingsScreen.${posType === 'Goodcom' && (currentPosType === 'Menuu' || currentPosType === 'Email POS') ? 'msgFirstRowGoodcom' : 'msgFirstRow'}`)} ${i18n.t('screens:posSettingsScreen.msgFirsRowSecondHalf')}`,
            secondRow: i18n.t('screens:posSettingsScreen.msgSecondRow')
        };

        const wipeMenutextData = {
            header: i18n.t('screens:posSettingsScreen.msgHeaderWipeMenu'),
            firstRow: `${i18n.t('screens:posSettingsScreen.msgFirstRowWipeMenu')} ${i18n.t('screens:posSettingsScreen.msgFirsRowSecondHalf')}`,
            secondRow: i18n.t('screens:posSettingsScreen.msgSecondRow')
        };

        let posIsPixelPoint = false;
        let posIsDeliverect = false

        if (this.state.type) {
            posIsPixelPoint = (this.state.type && this.state.type.id === 5) && this.state.type.value === "Par Pixelpoint";
            posIsDeliverect = (this.state.type && this.state.type.id === 7) && this.state.type.value === "Deliverect";
        }

        this.copyStateFromProps();

        if (Number(this.props.match.params.id) !== -1) {
            return (
                <Fragment>
                    <div style={containerStyle}>
                    {currentPosType === 'Andromeda' ? 
                    <Row style={{display: 'flex', justifyContent: 'space-between'}}>{this.renderHeading()}{this.renderInfoMessage()}</Row>
                    :
                    <Row>{this.renderHeading()}</Row>}
                        <div style={{ marginLeft: 15 }}>
                            {(this.props.user.canAccessPosSettings) ? this.renderPosSettingsForm() : this.renderPasswordVerification()}
                        </div>
                        <ConfirmationScreen
                            isOpen={this.state.confirmationScreenOpened}
                            onToggle={this.toggleConfirmationScreen}
                            onSave={this.updatePosSettings}
                            message={textData}
                        />
                        <ConfirmationScreen
                            isOpen={this.state.wipeMenuConfirmationScreenOpened}
                            onToggle={this.wipeMenuToggle}
                            onSave={this.wipeMenuConfirm}
                            message={wipeMenutextData}
                        />
                        <ImportMenuFromCSVScreen
                            isOpen={this.state.importMenuScreenOpened}
                            onToggle={this.toggleImportMenuFromCSVScreen}
                            restaurantId={this.props.match.params.id} />
                    </div>
                    <div hidden={!this.props.user.canAccessPosSettings} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {this.renderFormSaveButton()}
                        {!posIsPixelPoint && !posIsDeliverect ? this.renderImportMenuButton() : null}
                        {this.renderWipeMenuButton()}
                    </div>
                </Fragment>
            );
        } else {
            return (
                <div style={errorContainerStyle} className="errorIcon">
                    <h5 style={errorMessage}>{i18n.t('common:validations.settingsFirstMsg')}</h5>
                    <MaterialIcon icon="warning" color="#dbdadb" size={40} />
                </div>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        restaurant: state.restaurant,
        posTypes: state.posTypes,
        posSettings: state.posSettings
    };
};

export default connect(mapStateToProps, { loadPosSettings, loadPosTypes, loadTimezones, savePosSettingsData, importMenu, canUserAccessPosSettings, resetUserAccessToPos, wipeMenu, sendMenuuOrderHubLogs, activateMenu })(PosSettingsScreen);

let styles = {
    parentContainerStyle: {
        backgroundColor: '#fafafa'
    },
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        padding: '10px 0px 10px 15px',
        width: '100%'
    },
    posTypeSelectGroup: {
        display: "flex",
        width: "45%",
        marginBottom: 2
    },
    labelSelectStyle: {
        display: "flex",
        alignItems: "center",
        margin: "0px 12px",
        width: "30%"
    },
    posTypeFieldGroups: {
        display: "flex",
        width: '45%'
    },
    posTypeInputStyle: {
        flex: 2
    },
    posAdditionalFields: {
        display: "flex",
        justifyContent: "flex-start",
        paddingLeft: ".5em"
    },
    labelStyle: {
        width: '30%',
        display: "flex",
        alignItems: 'center',
        margin: "0px 10px",
        color: '#000'
    },
    posTypeSelectStyle: {
        flex: 2
    },
    autoSyncLabel: {
        margin: 10,
        width: '100%'
    },
    asyncTimeGroups: {
        display: "flex",
        width: "59%",
        justifyContent: "flex-start",
        paddingLeft: "0.9em"
    },
    autoSyncTimeContainer: {
        display: "flex",
        justifyContent: "flex-end",
        width: "30%"
    },
    posAsyncTimeInput: {
        width: 100,
        float: 'left',
        marginRight: 5
    },
    errorContainerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #c93a11',
        paddingBottom: 10,
        paddingTop: 60,
        paddingLeft: 15,
        height: 200,
        textAlign: 'center',
    },
    errorMessage: {
        color: "#c3c3c3",
    },
    importBtn: {
        marginLeft: 15
    },
    wipeMenuBtn: {
        marginLeft: 15
    },
    labelAutosyncTimeStyle: {
        display: "flex",
        width: "30%",
        alignItems: "center",
        margin: "0px 10px;",
        color: "rgb(0, 0, 0)"
    },
    marginLeft: {
        marginLeft: 10
    },
    syncTimeColor: {
        color: '#737373'
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    spaceBetween: {
        paddingLeft: 4
    },
    importPadding: {
        paddingLeft: 2
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/pos/PosSettingsScreen.js